import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Tooltip } from '@mui/material';
import Swal from 'sweetalert2';
import toast from 'react-hot-toast';

import ConnectToSafalMyBuy from '../sections/SettingTabs/ProfileTabs/ConnectToSafalMyBuy';
import { disconnectSafalMyBuyUser, getSafalMyBuyUserInfo } from '../services/Service';
import { setSafalMyBuyState } from '../store/SafalMyBuySlice';

const ConnectToSafalMyBuyButton = () => {
  const dispatch = useDispatch();
  const globalToggleState = useSelector((state) => state.globalToggleState);
  const safalMyBuyState = useSelector((state) => state.safalMyBuyState);
  const [isDisableAll, setIsDisableAll] = useState(false);
  const [connectToSafalMyBuyModal, setConnectToSafalMyBuyModal] = useState({
    open: false,
  });

  const onCloseConnectToSafalMyBuyModal = () => {
    setConnectToSafalMyBuyModal({ open: false });
  };
  const onOpenConnectToSafalMyBuyModal = () => {
    setConnectToSafalMyBuyModal({ open: true });
  };

  const onClickDisconnect = async () => {
    try {
      setIsDisableAll(true);
      const result = await Swal.fire({
        title: 'Disconnect from SafalMyBuy?',
        text: 'Are you sure you want to disconnect from SafalMyBuy? This may affect event expense tracking and purchase management.',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes',
        appendTo: 'body',
        customClass: {
          container: 'my-swal', // Add a custom class for styling
        },
        onBeforeOpen: () => {
          // Set a higher zIndex for the Swal modal
          document.querySelector('.my-swal').style.zIndex = 999999;
        },
      });

      if (!result.isConfirmed) return;
      const resX = await disconnectSafalMyBuyUser({
        safalMyBuyUserId: safalMyBuyState?.id,
      });
      if (resX.status === 200) {
        getSafalMyBuyUserInfo().then((resXX) => {
          const res_data = resXX?.data?.data || null;
          dispatch(setSafalMyBuyState(res_data));
        });
        toast.success('Disconnect from SafalMyBuy Successful');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  return (
    <>
      {safalMyBuyState?.id ? (
        <Tooltip title={`Disconnect from ${safalMyBuyState?.firstName} ${safalMyBuyState?.lastName}`}>
          <button
            onClick={onClickDisconnect}
            disabled={isDisableAll}
            style={{
              backgroundColor: 'transparent',
              border: '1px solid #d33',
              color: '#d33',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '12px',
              height: '45px',
              borderRadius: '30px',
              padding: '0 20px',
              marginTop: '35px',
            }}
          >
            <img
              src="/assets/images/safalmybuy_logo.png"
              style={{ height: '24px', objectFit: 'contain' }}
              alt="safalmybuy_logo"
            />
            <span>Disconnect</span>
          </button>
        </Tooltip>
      ) : (
        globalToggleState?.syncWithSafalMyBuy === 'YES' && (
          <Tooltip title="Connect to SafalMyBuy">
            <button
              disabled={isDisableAll}
              onClick={onOpenConnectToSafalMyBuyModal}
              style={{
                backgroundColor: 'transparent',
                border: '1px solid #3D71FF',
                color: '#3D71FF',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '12px',
                height: '45px',
                borderRadius: '30px',
                padding: '0 20px',
                marginTop: '35px',
              }}
            >
              <img
                src="/assets/images/safalmybuy_logo.png"
                style={{ height: '24px', objectFit: 'contain' }}
                alt="safalmybuy_logo"
              />
              <span>Connect</span>
            </button>
          </Tooltip>
          //   <Button
          //     color="primary"
          //     variant="contained"
          //     onClick={onOpenConnectToSafalMyBuyModal}
          //     sx={{
          //       height: '45px',
          //       backgroundColor: '#3D71FF',
          //       borderRadius: '30px',
          //       mt: '35px',
          //       textTransform: 'none',
          //     }}
          //   >
          //     Connect to SafalMyBuy
          //   </Button>
        )
      )}
      <ConnectToSafalMyBuy open={connectToSafalMyBuyModal.open} onClose={onCloseConnectToSafalMyBuyModal} />
    </>
  );
};

export default ConnectToSafalMyBuyButton;
